import { saveAs } from 'file-saver';
import moment from 'moment';
import { useCallback, useContext } from 'react';
import { storesContext } from '../../../stores/storesContext';
import { errorToast } from '../toasts/ToastUtils';

export const useDownloadScanningReport = () => {
  const userStore = useContext(storesContext);
  const propertiesStore = userStore.propertiesStore;

  const bearerToken = userStore.bearerToken;
  const selectedDatabase = userStore.selectedDatabase;
  const propertyIdentifier = propertiesStore.selectedProperty.identifier;
  const propertyName = propertiesStore.selectedProperty.name;

  const downloadReport = useCallback(
    async (report) => {
      try {
        const url = `${process.env.REACT_APP_PROPERTIES_API_URL}api/fruition/crop-scanning/reports/${report.key}`;
        const response = await fetch(url, {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
            Accept: 'application/pdf',
            seasonalDatabase: selectedDatabase
          }
        });
        if (!response.ok) {
          const status = response.status;
          if (status === 404) {
            errorToast('Report not found.', 'download-report-error');
          } else {
            errorToast('Failed to download report.', 'download-report-error');
          }
          return;
        }
        const blob = await response.blob();
        let fileName = `${moment(report.dt).format(
          'YYYYMMDD'
        )}-${propertyIdentifier}-${propertyName}-${report.blockCode}-${
          report.scanType
        }-${report.stage}-${report.reportType}-${report.pdfType}`;
        // Remove '.' from the file name to ensure the file type is set to 'pdf'.
        fileName = fileName.replace('.', '');
        // Save file.
        saveAs(blob, fileName);
      } catch (err) {
        console.error(err);
        errorToast('Failed to download report.', 'download-report-error');
      }
    },
    [bearerToken, propertyIdentifier, propertyName, selectedDatabase]
  );

  return downloadReport;
};

